import * as localforage from "localforage";
import axios from "axios";

const generateRecursiveList = (json = []) => {
  let treeData = [];
  if (json) {
    json.map((res, index) => {
      if (Array.isArray(res.children) && res.children.length > 0) {
        treeData.push({
          title: res.name,
          num: res.devices,
          key: res.id,
          parent_id: res.parent_company_id,
          children: generateRecursiveList(res.children)
        });
      } else {
        treeData.push({
          title: res.name,
          num: res.devices,
          key: res.id,
          parent_id: res.parent_company_id,
          isLeaf: true // means the last layer
        });
      }
      return treeData;
    });
  }

  return treeData;
};

export const getCompanyTreeApi = async () => {
  const companyId = await localforage.getItem("companyId");
  const user = await localforage.getItem("user");

  let response = await axios({
    url: `/api/v2/companies/devices`,
    method: "GET",
    params: {
      company_id: companyId,
      user_id: user.id
    }
  });

  return generateRecursiveList(response.data.companies);
};
